
import { BarChart3, Package, Users, Truck, AlertTriangle, TrendingUp, DollarSign, Activity } from "lucide-react"
import styles from "./analytics-home-page.module.css"
import { Link } from "react-router-dom"
import { useCallback, useEffect, useState } from "react"
import { api } from "@/utils/apiService"
import { useAuth } from "@/components/context/AuthContext"
import GlobalLoader from "@/components/Loading/GlobalLoader"
import { useTheme } from "@/components/context/ThemeContext"

export default function AnalyticsHomePage() {
  const { token } = useAuth()
  const {theme} = useTheme()
  const [loading, setLoading] = useState(false)
  const [quickStats, setQuickStats] = useState([
    { icon: <TrendingUp size={24} />, label: "Revenue Today", value: "", color: "#00d4ff" },
    { icon: <DollarSign size={24} />, label: "Monthly Profit", value: "", color: "#a855f7" },
    { icon: <Activity size={24} />, label: "Orders Today", value: "", color: "#22c55e" },
  ])

  const adminSections = [
    {
      title: "Analytics Dashboard",
      description: "View comprehensive analytics, profit metrics, and live orders",
      icon: <BarChart3 size={40} />,
      link: "/admin/analytics/dashboard",
      color: "#00d4ff",
    },
    {
      title: "Product Analytics",
      description: "Track product performance, best sellers, and inventory insights",
      icon: <Package size={40} />,
      link: "/admin/analytics/products",
      color: "#a855f7",
    },
    {
      title: "User Analytics",
      description: "Monitor user statistics, VIP analysis, and retention metrics",
      icon: <Users size={40} />,
      link: "/admin/analytics/users",
      color: "#22c55e",
    },
    {
      title: "Supplier Analytics",
      description: "Analyze supplier performance, costs, and anomaly detection",
      icon: <Truck size={40} />,
      link: "/admin/analytics/suppliers",
      color: "#f59e0b",
    },
    {
      title: "Alerts Management",
      description: "View and manage system alerts, warnings, and critical issues",
      icon: <AlertTriangle size={40} />,
      link: "/admin/analytics/alerts",
      color: "#ef4444",
    },
  ]

  const fetchDashboard = useCallback(async () => {
    setLoading(true)
    try {
      const res = await api.get("/admin/analytics/dashboard", {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })

      console.log(res)
      setQuickStats(prevStats => [
        { ...prevStats[0], value: `₹${res.data.data.today.totalRevenue}` },
        { ...prevStats[1], value: `₹${res.data.data.thisMonth.totalProfit}` },
        { ...prevStats[2], value: `${res.data.data.thisMonth.orderCount}` },
      ])
    } catch (error) {
      console.log("Dashboard Error ::", error)
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    fetchDashboard()
  }, [fetchDashboard])


  return (
    <div className={`${styles.adminHomePage} ${theme==="dark"?"dark":""}`}>
      <div className={styles.header}>
        <div>
          <h1>Admin Dashboard</h1>
          <p>Pixel Moon Store Management Portal</p>
        </div>
      </div>

      {loading ? (
        <GlobalLoader
          isLoading={loading}
          variant="spinner"
          message="Loading Dashboard Analytics"
          fullScreen={false}
        />
      ) : (
        <div className={styles.quickStats}>
          {quickStats.map((stat, index) => (
            <div key={index} className={styles.quickStatCard}>
              <div className={styles.statIcon} style={{ color: stat.color }}>
                {stat.icon}
              </div>
              <div className={styles.statInfo}>
                <div className={styles.statLabel}>{stat.label}</div>
                <div className={styles.statValue} style={{ color: stat.color }}>
                  {stat.value}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      <div className={styles.sectionsGrid}>
        {adminSections.map((section, index) => (
          <Link key={index} to={section.link} className={styles.sectionCard}>
            <div className={styles.cardHeader}>
              <div className={styles.cardIcon} style={{ color: section.color }}>
                {section.icon}
              </div>
            </div>
            <div className={styles.cardContent}>
              <h3>{section.title}</h3>
              <p>{section.description}</p>
            </div>
            <div className={styles.cardFooter} style={{ borderColor: section.color }}>
              <span style={{ color: section.color }}>View Details →</span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  )
}
